import LeaveConfirm from './leave-confirm';

export default LeaveConfirm;
